"use client";

import { useMutation } from "@tanstack/react-query";
import { showToast } from "@/components/ui/sonner";
import { forgotPassword } from "@/lib/api/generated";
import type { ForgotPasswordRequest } from "@/lib/api/model";

export function useForgotPassword() {
  return useMutation({
    mutationFn: (data: ForgotPasswordRequest) => forgotPassword(data),
    onError: (error: Error) => {
      showToast.error("Reset failed", {
        description: error.message || "Failed to send reset link.",
      });
    },
  });
}
